import type { IAddress } from "@bbj-types/address";
import type { ObjectId, Override } from "@bbj-types/utils";
import type { IWorkshop } from "@bbj-types/workshop";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";
import type { TGetWorkshop } from "./getWorkshop";

interface IPatchWorkshopBody {
  sessionType?: string;
  otherAnimators?: ObjectId[];
  date?: Date | null;
  startTime?: Date | null;
  endTime?: Date | null;
  convocationTimes?: {
    _id?: ObjectId;
    time: Date;
  }[];
  isDone?: boolean;
  isCancelled?: boolean;
  description?: string | null;
  organizer?: string | null;
  address?: IAddress;
  mainAnimator?: ObjectId | null;
}

export type TPatchWorkshopResponse = Override<
  TGetWorkshop,
  { participants: Pick<IWorkshop["participants"][number], "candidate" | "convocationTime">[] }
>;

export const usePatchWorkshop = () => {
  const [state, execute, cancel] = workshopsAxios<TPatchWorkshopResponse, IPatchWorkshopBody, unknown>(
    {
      url: "/",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, data: IPatchWorkshopBody) => {
      return execute({
        url: `/${id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
